module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.8ab4a218.png";